import React, { useEffect } from "react";
import classes from "./PrintRecipt.module.css";
import HeaderNav from "../../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../../Components/Footer/Footer";
import qrcode from "../../../Assets/customer_receipt_qr.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BarChart2,
  Filter,
  CalendarClock,
  Mail,
  ArrowLeft,
  Printer,
  Download,
  Settings,
} from "lucide-react";

const PrintRecipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { receipt, api, metadata } = location.state || {};
  const issuedAt = new Date().toLocaleString();

  // Auto-open print dialog when preview mounts
  useEffect(() => {
    if (location.state) {
      const id = setTimeout(() => {
        try { window.print(); } catch (e) { }
      }, 150);
      return () => clearTimeout(id);
    }
  }, [location.state]);

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  if (!location.state) {
    return (
      <div className={classes.errorPage}>
        <h2>Receipt data not found.</h2>
        <button onClick={() => navigate("/dashboard")}>Go to Dashboard</button>
      </div>
    );
  }

  const printInvoice = () => {
    window.print();
  };



  return (
    <div>
      <div className={classes.noPrint}>
        <HeaderNav activePage={pageMap[location.pathname]} />
      </div>
      <div className={classes.Container}>
        {/* Action Buttons */}
        <div className={classes.actions}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>
        <div className={classes.act}>
          <form className={classes.form}>
            <div className={classes.group}>
              <label>Period:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>Current month</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>Group by:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>None</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>Start Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>End Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <button className={classes.greenBtn}>
                <BarChart2 size={16} style={{ marginRight: "6px" }} />
                Run Report
              </button>
            </div>
          </form>

          <div className={classes.iconbars}>
            <div className={classes.iconbarr}>
              <div className={classes.iconbar}>
                <Filter size={16} style={{ marginRight: "6px" }} />
                Filter
              </div>
              <div className={classes.iconbar}>
                <CalendarClock size={16} style={{ marginRight: "6px" }} />
                Schedule
              </div>
            </div>
           
          </div>
        </div>
        <div className={classes.matron}>
          <button className={classes.backButton} onClick={() => navigate(-1)}>
            <ArrowLeft size={16} style={{ marginRight: "6px" }} />
          </button>
        </div>
        <div className={`${classes.containere} ${classes.printable}`}>
        <div className={classes.iconbarss}>
              <div className={classes.iconbar}>
                <Mail size={16} />
              </div>
              <div className={classes.iconbar}>
                <Printer size={16} onClick={printInvoice} />
              </div>
              <div className={classes.iconbar}>
                <Download size={16} />
              </div>
              <div className={classes.iconbar}>
                <Settings size={16} />
              </div>
            </div>
          <div className={classes.firstbar}>
            <div className={classes.promixfirst}>
              <div className={classes.promixfirstdivqrcode}> 
                <div className={classes.pro1}>
                <h1 className={classes.companyName}>Promix Accounting</h1>
                <div className={classes.procs}>
                  <h2 className={classes.pro2}>{issuedAt}</h2>
                </div>
                <div className={classes.profirst}>
                  <div className={classes.call}>
                    <h2 className={classes.pro2}>Receipt#</h2>
                    <h2 className={classes.pro2}>Receipt Date</h2>
                    <h2 className={classes.pro2}>Mode</h2>
                  </div>
                  <div className={classes.resp}>
                    <h2 className={classes.pro2}>
                      {api?.receipt_no || api?.reference || api?.id}
                    </h2>
                    <h2 className={classes.pro2}>
                      {api?.created_at ? new Date(api.created_at).toLocaleDateString() : new Date().toLocaleDateString()}
                    </h2>
                    <h2 className={classes.pro2}>{metadata?.payment_mode_label || ''}</h2>
                  </div>
                </div>
              </div>
              <div className={classes.grimgcontainer}>
                <div className={classes.prosecond}>
                  <h1 className={classes.prosec}>Receipt</h1>
                  {/* <img src={receipt?.logo || ''} alt="Logo" className={classes.logo} /> */}
                </div>
                <img src={qrcode} alt="qrcode" className={classes.grimg} />
              </div> </div>
             

              <div className={classes.prothird}>
                <h2 className={classes.pro4}>Receipt from</h2>
              </div>

              <div className={classes.profourth}>
                <div className={classes.pro1}>
                  <h1 className={classes.companyName}>{metadata?.customer_label || receipt?.receipt_for || ''}</h1>
                  <div className={classes.procs}>
                    <h2 className={classes.pro2}>Payment receipt for customer</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={classes.tableContainer}>
            <table className={classes.table}>
              <thead>
                <tr className={classes.tableHeader}>
                  <th>Description</th>
                  <th>Currency</th>
                  <th>Bank</th>
                  <th>Teller No</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className={classes.tableRow}>
                  <td>{receipt?.description || ''}</td>
                  <td>{metadata?.currency_label || ''}</td>
                  <td>{metadata?.bank_label || ''}</td>
                  <td>{receipt?.teller_number || ''}</td>
                  <td style={{ textAlign: 'right', paddingRight: '45px' }}>
                    {Number(receipt?.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={classes.lastbar}>
            <div className={classes.termsandcondi}>
              <div className={classes.pront}>
                <h1 className={classes.companyNames}>Terms and conditions</h1>
                <div className={classes.procst}>
                  <h2 className={classes.pro6}>Generated by Promix Accounting.</h2>
                  <h2 className={classes.pro6}>Please verify details before printing.</h2>
                </div>
              </div>
              <div className={classes.procsetion}>
                <div className={classes.procset}>
                  {/* <h2 className={classes.pro5}>Discount</h2>
          <h2 className={classes.pro5}>Sub Total</h2>
          <h2 className={classes.pro5}>VAT (7.5%)</h2>
          <h2 className={classes.pro5}>WHT (0.02%)</h2> */}
                  <h2 className={classes.pro5}>Total</h2>
                </div>
                <div className={classes.procset2}>
                  <h2 className={classes.pro5}>
                    {Number(receipt?.amount || 0).toLocaleString("en-NG", { minimumFractionDigits: 2 })}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className={classes.noPrint}>
      <Footer />
      </div>
    </div>
  );
};

export default PrintRecipt;

